import React from 'react';
import VoxelAutocompleteAllDomains from '../Autocomplete/VoxelAutocompleteAllDomains';
import SiteEvaluation from './SiteEvaluation/SiteEvaluation';
import { useSiteEvaluation } from './SiteEvaluation/useSiteEvaluation';
import VoxelSelect from '../../voxel/Forms/VoxelSelect';
import { DomainTypeGq } from '../../../graphql/projects/models/DomainTypeGq';
import { GenericOption } from '../../voxel/Forms/VoxelAutocomplete';

export interface DomainFormProps {
  protocolValue: string;
  domainValue: string;
  setProtocolValue: (value: string) => void;
  setDomainFormState: (valueFunc: (prev: DomainFormState) => DomainFormState) => void;
  disabled?: boolean;
  deleteDomainValue?: () => void;
  placeholder?: string;
  helperText?: string;
  showHelperText?: boolean;
  showLabels?: boolean;
  size?: 'sm' | 'md';
  flexGapClass?: string;
}

export interface DomainFormState {
  id?: number;
  protocol: string;
  domain: string;
  type: DomainTypeGq;
}

export const protocolOptions: GenericOption[] = [
  { value: 'https://', title: 'https://' },
  { value: 'http://', title: 'http://' },
];

const DomainForm: React.FC<DomainFormProps> = ({
  protocolValue,
  setProtocolValue,
  setDomainFormState,
  domainValue,
  disabled,
  deleteDomainValue,
  placeholder,
  helperText,
  showHelperText,
  showLabels,
  size = 'md',
  flexGapClass = 'gap-4'
}) => {
  // Site evaluation
  const siteEvaluation = useSiteEvaluation(protocolValue, domainValue);

  const setDomainAndProtocolValue = (value: string) => {
    const httpsDetection = value.includes(protocolOptions[0].value);
    const httpDetection = value.includes(protocolOptions[1].value);
    if (httpsDetection) {
      const cleanedDomain = value.replace(protocolOptions[0].value, '');
      setDomainFormState(prev => ({ ...prev, protocol: protocolOptions[0].value, domain: cleanedDomain }));
    } else if (httpDetection) {
      const cleanedDomain = value.replace(protocolOptions[1].value, '');
      setDomainFormState(prev => ({ ...prev, protocol: protocolOptions[1].value, domain: cleanedDomain }));
    } else {
      setDomainFormState(prev => ({ ...prev, domain: value }));
    }
  };

  return (
    <div className={`w-full flex flex-row ${flexGapClass} flex-nowrap items-end`}>
      <div className="w-24">
        <VoxelSelect
          label={showLabels ? "Protocol" : null}
          labelPosition="top"
          options={protocolOptions}
          selectedOptionValue={protocolValue}
          setSelectedOption={(option: GenericOption) => {
            const optValue = protocolOptions?.find(t => t.value === option.value)?.value ?? ''
            setProtocolValue(optValue)
          }}
          inputWidthClass="w-full"
          disabled={disabled}
          size={size}
        />
      </div>
      <div className="grow">
        <VoxelAutocompleteAllDomains
          id={'url'}
          label={showLabels ? "Domain" : null}
          labelPosition="top"
          value={domainValue}
          setValue={setDomainAndProtocolValue}
          deleteValue={deleteDomainValue}
          placeholder={placeholder}
          maxLength={1000}
          disabled={disabled}
          helperText={helperText}
          showHelperText={showHelperText}
          inputWidthClass="w-full"
          maxHeightOptions={200}
          onBlur={() => siteEvaluation.handleEvaluateDomain(protocolValue + domainValue)}
          size={size}
        />
      </div>
      <div className="grow-0 w-16">
        <SiteEvaluation
          domainValue={domainValue}
          siteEvaluationState={siteEvaluation.siteEvaluationState}
        />

      </div>
    </div>
  );
};

export default DomainForm;
